import type { ConfigurationsResponse } from "common";
import { ROUTES } from "@via/utils/constants.tsx";

/** What /scan and /a/<code> say when the v2 metadata interface is off (legacy-2-4). */
export const SCAN_UNAVAILABLE_MESSAGE = "Metadata is not available here.";

/** Scanning lands on the v2 metadata page, so it needs metadata on and the v2 interface on. */
export const isScanAvailable = (
  config?: Pick<ConfigurationsResponse, "ENABLE_VMETA" | "USE_VMETA_V2"> | null
): boolean => Boolean(config?.ENABLE_VMETA && config?.USE_VMETA_V2);

/** The navigation with a Scan entry right after Sample Trackers, when scanning is available. */
export const withScanNavigation = <T extends { href: string }>(
  options: T[],
  entry: T,
  enabled: boolean
): T[] => {
  if (!enabled) return options;
  const index = options.findIndex(
    option => option.href === ROUTES.SAMPLE_TRACKERS
  );
  if (index === -1) return [...options, entry];
  return [...options.slice(0, index + 1), entry, ...options.slice(index + 1)];
};
